import InfoIcon from "@mui/icons-material/Info";
import { Divider, IconButton, Stack, Tooltip, Typography, Ul, UlItem } from "@financeable-com-au/financeable-ui";

interface RequiredFieldsTooltipProps {
  fields: string[];
  onShowErrors: () => void;
}

const RequiredFieldsTooltip = ({ fields, onShowErrors }: RequiredFieldsTooltipProps) => (
  <Tooltip
    title={
      <Stack padding={2} flexDirection="column" rowGap={2}>
        <Typography level="body-sm" bold>
          Remaining required fields
        </Typography>
        <Divider />
        {fields.length > 0 ? (
          <Ul lineHeight={1.2}>
            {fields.map((label) => (
              <UlItem key={label}>{label}</UlItem>
            ))}
          </Ul>
        ) : (
          <Typography level="body-sm">All required fields are filled!</Typography>
        )}
      </Stack>
    }
  >
    <IconButton
      aria-label="Show remaining required fields"
      isRounded={true}
      size="sm"
      variant="inline"
      intent="neutral"
      onClick={onShowErrors}
    >
      <InfoIcon sx={{ fontSize: "1.1rem" }} />
    </IconButton>
  </Tooltip>
);

export default RequiredFieldsTooltip;
